import { MutableRefObject } from 'react';

import { MILLISECONDS_PER_SECOND } from 'constants/date';

export const startTimer = (
  timerRef: MutableRefObject<NodeJS.Timer | undefined>,
  callback: () => void,
  clearMs: number,
) => {
  clearTimeout(timerRef.current);
  timerRef.current = setTimeout(callback, clearMs);
};

export const formatTimer = (time: number, short = false) => {
  if (short) {
    return Math.round(time / MILLISECONDS_PER_SECOND) + 's';
  }
  return (
    Math.round(time / MILLISECONDS_PER_SECOND) +
    ' second' +
    (Math.round(time / MILLISECONDS_PER_SECOND) > 1 ? 's' : '')
  );
};
